import React from 'react'
import moment from 'moment'
import CheckMarkIcon from '@material-ui/icons/CheckCircle'
import Radio from '@material-ui/core/Radio'
import UpdateMaterial from './UpdateMaterial'

const Loads = props => {
  const {
    currentItemSelectedLoads,
    confirmLoad,
    setConfirmLoad,
    updateMaterial,
    setUpdateMaterial,
    checkedLoads,
    setCheckedLoads,
    enterMaterial,
    setEnterMaterial,
    activeData
  } = props

  const handleLeftButton = () => {
    if (confirmLoad || updateMaterial || enterMaterial) {
      setEnterMaterial(false)
      setUpdateMaterial(false)
      setConfirmLoad(false)
      setCheckedLoads([])
    } else {
      setConfirmLoad(true)
    }
  }

  const handleRightButton = () => {
    if (!updateMaterial && !confirmLoad) {
      setUpdateMaterial(true)
    } else if (confirmLoad) {
      // confirm load / material
      setConfirmLoad(false)
    }
    if (updateMaterial) {
      setEnterMaterial(true)
    }
    if (enterMaterial) {
      setUpdateMaterial(false)
      setEnterMaterial(false)
      setCheckedLoads([])
    }
  }

  const handleRadioButton = id => {
    const loadIndex = checkedLoads.findIndex(item => item === id)
    if (loadIndex > -1) {
      const newList = checkedLoads.filter(item => item !== id)
      setCheckedLoads(newList)
    } else {
      setCheckedLoads([...checkedLoads, id])
    }
  }

  let haulObj = {}
  currentItemSelectedLoads.forEach(load => (haulObj[load.haulId] = ++haulObj[load.haulId] || 1))

  return (
    <div>
      {!enterMaterial &&
        Object.keys(haulObj).map((haulId, i) => {
          return (
            <div key={i}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <span style={{ color: '#3E3E41' }}>Haul {haulId}</span>
                </div>
                <div>
                  <span
                    style={{
                      fontSize: '10px',
                      color: '#6B6C70'
                    }}
                  >
                    {updateMaterial
                      ? `${checkedLoads.length} selected`
                      : `${haulObj[haulId]} loads`}
                  </span>
                </div>
              </div>
              <div style={{ margin: '20px 0 40px' }}>
                {currentItemSelectedLoads.reduce((acc, load, i) => {
                  if (load.haulId === haulId) {
                    acc.push(
                      <div key={i} style={{ display: 'flex' }}>
                        {updateMaterial && (
                          <div
                            style={{ display: 'flex' }}
                            onClick={() => handleRadioButton(load._id)}
                          >
                            <Radio
                              checked={checkedLoads.includes(load._id)}
                              value={load._id}
                              style={{ color: '#1565D8', padding: '0 16px 0 0' }}
                            />
                          </div>
                        )}
                        <div
                          style={
                            acc.length > 0
                              ? { marginTop: '16px', width: '100%' }
                              : { width: '100%' }
                          }
                        >
                          <div
                            style={{
                              height: '92px',
                              boxShadow: '0px 1px 3px #00000029',
                              borderRadius: '5px',
                              width: '100%'
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: '#F6F9FD',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}
                            >
                              <span
                                style={{ fontSize: '16px', color: '#3E3E41', paddingLeft: '16px' }}
                              >
                                Load {acc.length + 1}
                              </span>
                              {confirmLoad && !load.materialConfirmed ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    marginRight: '6px',
                                    alignItems: 'center'
                                  }}
                                >
                                  <span style={{ color: '#9FA0A5', paddingRight: '8px' }}>
                                    tap to confirm
                                  </span>
                                  <CheckMarkIcon style={{ color: '#EAEDF3' }} />
                                </div>
                              ) : null}
                              {load.materialConfirmed && (
                                <CheckMarkIcon style={{ color: '#B8D5FC', marginRight: '6px' }} />
                              )}
                            </div>
                            <div style={{ display: 'flex', height: '52px' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  width: '20%',
                                  justifyContent: 'center',
                                  paddingLeft: '16px',
                                  borderRight: '1px solid #E7E7EC',
                                  marginTop: '5px',
                                  minWidth: '52px'
                                }}
                              >
                                <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Pick Up</span>
                                <span
                                  style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}
                                >
                                  {load.arriveTimeA
                                    ? moment(load.arriveTimeA).format('HH:mm')
                                    : '-'}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  width: '20%',
                                  justifyContent: 'center',
                                  paddingLeft: '16px',
                                  borderRight: '1px solid #E7E7EC',
                                  marginTop: '5px',
                                  minWidth: '52px'
                                }}
                              >
                                <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Drop Off</span>
                                <span style={{ fontSize: '16px', color: '#3E3E41' }}>
                                  {load.arriveTimeB
                                    ? moment(load.arriveTimeB).format('HH:mm')
                                    : '-'}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  paddingLeft: '16px',
                                  marginTop: '5px',
                                  width: '50%'
                                }}
                              >
                                <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Material</span>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-end'
                                  }}
                                >
                                  <span style={{ fontSize: '16px', color: '#3E3E41' }}>
                                    {load.material}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  return acc
                }, [])}
              </div>
            </div>
          )
        })}
      {currentItemSelectedLoads.length && !enterMaterial ? (
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            zIndex: 1
          }}
        >
          <div
            style={{
              margin: '0 8px 16px 8px',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <div style={{ width: '48%' }}>
              <div
                style={{
                  width: '100%',
                  height: '40px',
                  background:
                    confirmLoad || updateMaterial
                      ? '#fff'
                      : 'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box',
                  boxShadow: '0px 1px 3px #00000029',
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onClick={handleLeftButton}
              >
                <span style={{ color: confirmLoad || updateMaterial ? '#1565D8' : '#fff' }}>
                  {confirmLoad || updateMaterial ? 'Cancel' : 'Confirm Load'}
                </span>
              </div>
            </div>
            <div style={{ width: '48%' }}>
              <div
                style={{
                  width: '100%',
                  height: '40px',
                  background:
                    confirmLoad || (updateMaterial && !checkedLoads.length)
                      ? '#fff'
                      : 'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box',
                  boxShadow: '0px 1px 3px #00000029',
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  pointerEvents: updateMaterial && !checkedLoads.length ? 'none' : ''
                }}
                onClick={handleRightButton}
              >
                <span
                  style={{
                    color:
                      confirmLoad || (updateMaterial && !checkedLoads.length) ? '#1565D8' : '#fff'
                  }}
                >
                  {confirmLoad ? 'Ok' : updateMaterial ? 'Next' : 'Update Material'}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {enterMaterial && (
        <UpdateMaterial
          checkedLoads={checkedLoads}
          activeData={activeData}
          handleLeftButton={handleLeftButton}
          handleRightButton={handleRightButton}
        />
      )}
      <div style={{ height: '10px' }} />
    </div>
  )
}

export default Loads
